import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  updateBidsList,
  placeBid,
  findBidData
} from 'src/redux/actions/bidding';
import { sendNotification } from 'src/redux/actions/notifications';
import {
  getLocale,
  getAllStock,
  getAllStockIds,
  getUser,
  getTimeStamp,
  getBidData
} from 'src/redux/selectors';
import {
  addStock,
  deleteStock,
  findAllStock,
  deleteStockImage,
  findAllAccess,
  findAllStockRequests
} from 'src/redux/actions/stock';
import { findTechnicians } from 'src/redux/actions/request';
import { withRouter, Link } from 'react-router-dom';
import { findAllSites, findAllSitesInventory, setSelectedSite } from 'src/redux/actions/sites';
import { findAllUsers } from 'src/redux/actions/admin';
import { getSitesAvailableToUser } from 'src/utils/siteAccess';

class Stock extends Component {
  render = () => {
    const {
      Layout,
      currentLocale,
      stock,
      inventorySites,
      user,
      findAllStock,
      findAllUsers,
      addStock,
      findAllSitesInventory,
      deleteStock,
      sendNotification,
      deleteStockImage,
      findAllSites,
      findAllStockRequests,
      sites,
      findAllAccess,
      access,
      findTechnicians,
      push,
      history
    } = this.props;
    return (
      <Layout
        currentLocale={currentLocale}
        stock={stock}
        user={user}
        access={access}
        findAllStock={findAllStock}
        findAllUsers={findAllUsers}
        findAllSitesInventory={findAllSitesInventory}
        findAllAccess={findAllAccess}
        addStock={addStock}
        findAllStockRequests={findAllStockRequests}
        deleteStockImage={deleteStockImage}
        deleteStock={deleteStock}
        sendNotification={sendNotification}
        push={push}
        findAllSites={findAllSites}
        sites={sites}
        selectedSite={this.props.selectedSite}
        setSelectedSite={this.props.setSelectedSite}
        inventorySites={inventorySites}
        history={history}
      />
    );
  };
}

const mapStateToProps = state => ({
  selectedSite: state.sites.selectedSite || null,
  currentLocale: getLocale(state) || {},
  sites: getSitesAvailableToUser(
    state.sites.allSites || [],
    getUser(state) || {}
  ),
  inventorySites: state.sites.inventorySites || [],
  access: state.stock.allAccess || [],
  stock: state.stock.allStock || [],
  user: getUser(state) || {}
});

const mapDispatchToProps = {
  setSelectedSite,
  getLocale,
  findAllStock,
  findAllUsers,
  addStock,
  deleteStockImage,
  deleteStock,
  findAllSitesInventory,
  findAllStockRequests,
  sendNotification,
  findAllSites,
  push
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Stock)
);
